import { useRef, useCallback } from 'react';

export const useProductListAPI = () => {
  const activeRequestRef = useRef(null);
  const lastRequestParamsRef = useRef(null);
  const lastRequestTimeRef = useRef(0);

  const callAPI = useCallback(async (apiFunction, params, forceCall = false) => {
    const paramsKey = JSON.stringify(params);
    const now = Date.now();
    
    // Only block if same params AND within 1 second (prevents rapid duplicates but allows refresh)
    if (!forceCall && 
        lastRequestParamsRef.current === paramsKey && 
        (now - lastRequestTimeRef.current) < 1000) {
      return null;
    }

    if (activeRequestRef.current) {
      activeRequestRef.current.cancelled = true;
    }

    const requestTracker = { cancelled: false };
    activeRequestRef.current = requestTracker;
    lastRequestParamsRef.current = paramsKey;
    lastRequestTimeRef.current = now;

    try {
      const result = await apiFunction(params);
      
      if (requestTracker.cancelled) {
        return null;
      }

      activeRequestRef.current = null;
      return result;
    } catch (error) {
      if (!requestTracker.cancelled) {
        activeRequestRef.current = null;
        throw error;
      }
      return null;
    }
  }, []);

  const resetTracker = useCallback(() => {
    if (activeRequestRef.current) {
      activeRequestRef.current.cancelled = true;
    }
    activeRequestRef.current = null;
    lastRequestParamsRef.current = null;
    lastRequestTimeRef.current = 0;
  }, []);

  return { callAPI, resetTracker };
};